import { Navigate, Outlet } from "react-router";
import { useEntrypointContext } from "../entrypoint/EntrypointContext";
import { useRootPath } from "../translation/useRootPath";
import { Route } from "./routes";

function ProtectedRoutes({
  partnerOnboardingRoute,
}: {
  partnerOnboardingRoute?: boolean;
}) {
  const entrypoint = useEntrypointContext();
  const rootPath = useRootPath();

  if (!entrypoint.rolle) {
    return <Navigate to={`${rootPath}/info`} replace />;
  }

  if (partnerOnboardingRoute && !entrypoint.partnerOnboardingParams) {
    return <Navigate to={`${rootPath}/${Route.Registrering}`} replace />;
  }

  if (!partnerOnboardingRoute && entrypoint.partnerOnboardingParams) {
    return <Navigate to={`${rootPath}/${Route.PartnerOnboarding}`} replace />;
  }

  return <Outlet />;
}

export default ProtectedRoutes;
